module.exports = {
	methods: {
		prepareMeta: function(){
			if(!this.model.title) this.model.additionalClasses.push('missingTitle');
		}
	}
};